import { nanoid } from "nanoid";
/**
 * https://github.com/tldraw/tldraw/blob/d683cc09432197e89bddacf2b706b5eaad40e399/packages/tlschema/src/records/TLShape.ts
 *
 * Changes:
 * 	- Commented out everything but a couple methods
 */ /* eslint-disable @typescript-eslint/no-explicit-any */ import { createRecordType, defineMigrations } from "@supersig/store";
import { T } from "@supersig/validate";
import { mapObjectMapValues } from "../../utils";
import { StyleProp } from "../legacy-styles/StyleProp";
import { createShapeValidator } from "../shapes/TLBaseShape";
// // evil type shit that will get deleted in the next PR
// type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (k: infer I) => void
// 	? I
// 	: never
// type Identity<T> = { [K in keyof T]: T[K] }
// /** @public */
// export type TLShapeProps = Identity<UnionToIntersection<TLDefaultShape['props']>>
// /** @public */
// export type TLShapeProp = keyof TLShapeProps
// /** @public */
// export type TLParentId = TLPageId | TLShapeId
/** @internal */ export const rootShapeVersions = {
    AddIsLocked: 1,
    HoistOpacity: 2,
    AddMeta: 3
};
/** @internal */ export const rootShapeMigrations = defineMigrations({
    currentVersion: rootShapeVersions.AddMeta,
    migrators: {
        [rootShapeVersions.AddIsLocked]: {
            up: (record)=>{
                return {
                    ...record,
                    isLocked: false
                };
            },
            down: (record)=>{
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                const { isLocked: _, ...rest } = record;
                return {
                    ...rest
                };
            }
        },
        [rootShapeVersions.HoistOpacity]: {
            up: ({ props: { opacity, ...props }, ...record })=>{
                return {
                    ...record,
                    opacity: Number(opacity ?? "1"),
                    props
                };
            },
            down: ({ opacity, ...record })=>{
                return {
                    ...record,
                    props: {
                        ...record.props,
                        opacity: opacity < 0.175 ? "0.1" : opacity < 0.375 ? "0.25" : opacity < 0.625 ? "0.5" : opacity < 0.875 ? "0.75" : "1"
                    }
                };
            }
        },
        [rootShapeVersions.AddMeta]: {
            up: (record)=>{
                return {
                    ...record,
                    meta: {}
                };
            },
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            down: ({ meta: _, ...record })=>{
                return {
                    ...record
                };
            }
        }
    }
});
/** @public */ export function isShape(record) {
    if (!record) return false;
    return record.typeName === "shape";
}
/** @public */ export function isShapeId(id) {
    if (!id) return false;
    return id.startsWith("shape:");
}
/** @public */ export function createShapeId(id) {
    return `shape:${id ?? nanoid()}`;
}
/** @internal */ export function getShapePropKeysByStyle(props) {
    const propKeysByStyle = new Map();
    for (const [key, prop] of Object.entries(props)){
        if (prop instanceof StyleProp) {
            if (propKeysByStyle.has(prop)) {
                throw new Error(`Duplicate style prop ${prop.id}. Each style prop can only be used once within a shape.`);
            }
            propKeysByStyle.set(prop, key);
        }
    }
    return propKeysByStyle;
}
/** @internal */ export function createShapeRecordType(shapes) {
    return createRecordType("shape", {
        migrations: defineMigrations({
            currentVersion: rootShapeMigrations.currentVersion,
            firstVersion: rootShapeMigrations.firstVersion,
            migrators: rootShapeMigrations.migrators,
            subTypeKey: "type",
            subTypeMigrations: mapObjectMapValues(shapes, (_, v)=>v.migrations ?? defineMigrations({}))
        }),
        scope: "document",
        validator: T.model("shape", T.union("type", mapObjectMapValues(shapes, (type, { props, meta })=>createShapeValidator(type, props, meta))))
    }).withDefaultProperties(()=>({
            x: 0,
            y: 0,
            rotation: 0,
            isLocked: false,
            opacity: 1,
            meta: {}
        }));
}
